import { useMutation, useQueryClient } from '@tanstack/react-query';
import { message } from 'antd';

import { useTranslation } from 'react-i18next';

import { NSKeys } from '@app/i18n';
import { UpdateWarehouseSchema } from '@app/models/wms';
import Api from '@app/services/api';

interface IProps {
  data: UpdateWarehouseSchema;
  uid: string;
}

export const useUpdateWarehouseQuery = () => {
  const client = useQueryClient();
  const commonT = useTranslation(NSKeys.common);

  return useMutation({
    mutationFn: async ({ data, uid }: IProps) => {
      return await Api.wms.putWarehouse(data, uid);
    },
    onSettled: async (_, __, { uid }) => {
      await client.invalidateQueries(['getWarehouses']);
      await client.invalidateQueries(['getWarehouse', uid]);
    },
    onSuccess: async () => {
      message.open({
        type: 'success',
        content: commonT.t('dataPatchSuccess'),
      });
    },
  });
};
